module.exports = __webpack_public_path__ + "img/time-limit.c4b9d5ef.png";